import { useState, type FormEvent } from 'react';
import { useAuth } from '../context/AuthContext';

export function LoginPage() {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true); setError(null);
    try { await login(username.trim(), password); }
    catch (err) { setError(String(err).includes('401') || String(err).toLowerCase().includes('invalid') ? 'Invalid username or password.' : String(err)); }
    finally { setBusy(false); }
  };

  return (
    <div className="login-shell">
      <form className="login-card" onSubmit={submit}>
        <div className="login-brand">PM Growth Simulation Dashboard</div>
        <p className="page-subtitle" style={{ marginBottom: '1.25rem' }}>Sign in to the PMO Growth Reform Unit workspace.</p>
        <label className="field-label">Username</label>
        <input className="field" autoComplete="username" value={username} onChange={(e) => setUsername(e.target.value)} required />
        <label className="field-label">Password</label>
        <input className="field" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        {error && <div className="error" style={{ marginTop: '0.75rem' }}>{error}</div>}
        <button className="btn-primary" type="submit" disabled={busy} style={{ marginTop: '1rem', width: '100%' }}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
